module.exports = __webpack_public_path__ + "static/media/994D1AFE-C250-4F7A-96E3-532F12D6EBAF.c74a2bb8.JPG";